import {Component, EventEmitter, Output} from "@angular/core";

@Component({
	selector: "activate-ccd-trial-unavailable-due-to-dealer-access",
	template: `
		<modal
			(close)="onModalClosed()"
			modalClasses="modal-wide"
			[clickToClose]="false">
			<header class="modal_header">
				<h2 class="text-center">
					Unable to Activate LTE & WiFi Trial
				</h2>
			</header>
			<div class="modal_body pt-4 pb-4 px-4">
				<div class="modal_content_box px-4">
					<div style="text-align: center;">
						<div>
							This aircraft is eligible for a trial of Connext LTE and WiFi services with your
							connected-cockpit device.
						</div>
						<br>
						<div>
							However, a dealer currently has access to manage aircraft on your account.
							<strong>Connext LTE & Wi-Fi trials cannot be claimed while a dealer has access to your account.</strong>
						</div>
						<br>
						<div>
							In order to activate your trial, you will need to wait until the dealer no longer has access,
							or you can revoke the dealer's access from the home page (if it is no longer needed).
						</div>
					</div>
				</div>
			</div>
			<footer class="modal_footer">
				<div style="text-align: center">
					<button
						(click)="onModalClosed()"
						class="button button-secondary py-1 px-4" type="button">
						OK
					</button>
				</div>
			</footer>
		</modal>
	`,
})
export class ActivateCcdTrialUnavailableDueToDealerAccessComponent {
	@Output() modalClosed = new EventEmitter();

	onModalClosed() {
		this.modalClosed.emit();
	}
}
